import { Link, Text } from "@chakra-ui/react";

export const EigenDisclaimer = () => {
  return (
    <Text
      color="textSecondary"
      fontSize="14px"
      lineHeight="20px"
      fontWeight="400"
    >
      By claiming, using, or transferring EIGEN tokens, you acknowledge and
      agree that EIGEN is issued solely by both the Eigen Foundation and Eigen
      Labs, Inc., and is subject to their respective Terms of Service, available
      at Eigen Foundation{" "}
      <Link
        color="textPrimary"
        fontWeight="600"
        textDecor="underline"
        href="https://docs.eigenfoundation.org/legal/terms-of-service"
        target="_blank"
      >
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link
        color="textPrimary"
        fontWeight="600"
        textDecor="underline"
        href="https://docs.eigenlayer.xyz/eigenlayer/legal/terms-of-service"
        target="_blank"
      >
        Eigen Labs Terms of Service.
      </Link>{" "}
      Kelp DAO solely facilitates access to the claim and disclaims all
      warranties and liabilities regarding the EIGEN tokens, as well as any
      third-party services, including those operated by Eigen Foundation or
      Eigen Labs.
    </Text>
  );
};
